import { useState, useMemo, useEffect, useContext } from 'react';
import { addNewForm, updateForm } from '../../../../services/firebase/form/formTable';
import { capitalizeObjKeys, filterByFormType } from '../../../../utils/utilities';
import { templateFields } from './templateConst';
import { useNavigate, useParams } from 'react-router-dom';
import { getFormByID } from '../../../../services/firebase/form/formTable';
import { ALERT_TYPE } from '../../../../constants/alert-type';
import { setAlert } from '../../../../state/action';
import FormContext from '../../../../context/form-context';
import generateUniqueId from 'generate-unique-id';

const useTemplateCreatorPage = () => {
    const { dispatch} = useContext(FormContext)
    const [templateState, setTemplateState] = useState({});
    const [showAlert, setShowAlert] = useState({ show: false, message: "", severity: "" });
    const [formName, setFormName] = useState("Create New Form");
    const [loaded, setLoaded] = useState(false);
    const { formId } = useParams();
    const navigate = useNavigate(); 

    useEffect(() => {
        
        //get All data from Forms Table
        const getForms = async () => {
            try {
                const data = await getFormByID(formId);
                setFormName(data.FormName + ` (${data.Form} - ${data.Type})`)
                
                setTemplateState({
                    form: data.Form,
                    formDescription: data.FormDescription,
                    formName: data.FormName,
                    localPath: data.localPath,
                })
                setLoaded(true);
                
            } catch (error) {  
                callAlertBar(true, `Form ID: ${formId} does not exist.`, ALERT_TYPE.ERROR)
                dispatch(setAlert({show: true, title: "ERROR" , body: `Form ID: ${formId} does not exist. <br><br> ${error}`}))
            }
        }

        if (formId) { getForms() }
        else{ 
            setLoaded(true) }

    }, [])

    const fields = useMemo(() => {
        const newTemplateFields = templateFields.map(field => {
            if (formId && (field.fieldVal === "form" || field.fieldVal === "type")) {
                return { ...field, disabled: true }; //additional disable property
            } else {
                return field; 
            }
        });
        return newTemplateFields; // Return the newTemplateFields
    }, [])

    const handleRichTextUpdate = (field, value) => {
        // const text = editor.getContent({format: "text"})
        // setTextVal(value)
        setTemplateState({ ...templateState, [field]: value })
    }

    const buttonAction = {
        handleClicked: () => {
            const defaultStyle = `<style> 
            * {font-family: "Roboto"; } 
             p{   font-size: 10px; margin: 5px;  }  

            </style>`
            callAlertBar(true, `Please open the browser console to see the converted html to string`, ALERT_TYPE.SUCCESS)
            console.log(defaultStyle + templateState.formTemplate);
        },
        handleSubmit: async () => {
            const newState = capitalizeObjKeys(templateState);
            // newState.IsRequired === "Yes" ? newState.IsRequired = true : newState.IsRequired = false
            
            try {
                if(formId){
                    //update thhe form
                   await updateForm(formId , newState)
                   await callAlertBar(true, `Form Update Saved Successfully!`, ALERT_TYPE.SUCCESS)
                   dispatch(setAlert({show: true, title: "Success" , body: `Form Update Saved Successfully!`}))
                }
                else{
                    // add new form

                    //document id
                    const randomDigits = generateUniqueId({length: 4, useLetters: false});
                    newState.DocID =`${newState.Form.toUpperCase()}_${newState.Type.toUpperCase()}_${randomDigits}`

                    const data = await addNewForm(newState);
                    await callAlertBar(true, `Submission Successful! <br/><br/> Template ID: ${data.DocID}`, ALERT_TYPE.SUCCESS)
                    dispatch(setAlert({show: true, title: "Success" , body: `Submission Successful! <br/><br/> Template ID: ${data.DocID}`}))
                    // setTimeout(() => {
                    //     navigate(`/admin/forms/edit/${data.DocID}`)
                    // },2000)
                }   
                
            } catch (error) {
                callAlertBar(true, `SUBMISSION ERROR: ${error}`, ALERT_TYPE.ERROR)
                dispatch(setAlert({show: true, title: "ERROR" , body: `SUBMISSION ERROR: ${error}`}))
            }

        }
    }

const handleFieldChange = (val, field) => {
        setTemplateState({ ...templateState, [field]: val })
    }

    const callAlertBar = (show, message, severity) => {
        setShowAlert({ show: show, message: message, severity: severity });
        if (severity !== ALERT_TYPE.ERROR) {
            setTimeout(() => {
                setShowAlert({ ...showAlert, show: false });
            }, 1000)
        }

    }

    return {
        templateState,
        buttonAction,
        handleRichTextUpdate,
        fields,
        handleFieldChange,
        showAlert,
        formName,
        loaded,
    }
}

export default useTemplateCreatorPage;